'use client';

import { useEffect, useRef, useState } from 'react';

/**
 * Tells the user when the connection drops or returns. Without it, failed
 * requests just surface as unrelated error toasts and users assume the app broke.
 */
export default function NetworkStatus() {
  // null = nothing to show, 'offline' = persistent, 'online' = brief "back online"
  const [state, setState] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    const goOffline = () => {
      clearTimeout(timer.current);
      setState('offline');
    };
    const goOnline = () => {
      setState('online');
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setState(null), 3000);
    };

    if (typeof navigator !== 'undefined' && navigator.onLine === false) goOffline();

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!state) return null;

  return (
    <div className={`ui-offline-banner ${state}`} role="status" aria-live="polite">
      {state === 'offline'
        ? "You're offline - changes won't be saved until you reconnect."
        : 'Back online.'}
    </div>
  );
}
